var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"docs-status"},[(_vm.status === true)?_c('span',{class:`docs-status-enabled ${_vm.statusClass}`},[_vm._v(" "+_vm._s(_vm.$t('docs_status_enable'))+" ")]):_c('span',{class:`docs-status-disabled ${_vm.statusClass}`},[_vm._v(" "+_vm._s(_vm.$t('docs_status_disable'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }